import {AutoMap} from '@automapper/classes';
import {TBaseModel, TListBaseModel} from './common/t-base.model';
import {ReminderLogStatusEnum, reminderLogStatusEnumToGeneralTypeModel} from '../enums/reminder-log-status.enum';
import {
  ReminderLogReadStatusEnum,
  reminderLogReadStatusEnumToGeneralTypeModel
} from '../enums/reminder-log-read-status.enum';
import {ReminderLogHighlightGetResponseDto} from '../dtos/reminder-log-highlight.dto';
import {FormField} from '../../core/decorators/form-field.decorator';
import {Validators} from '@angular/forms';
import {SourceTypeEnum} from '../enums/source-type.enum';

export class ReminderLogListModel extends TListBaseModel {
  @AutoMap()
  public title!: string;

  @AutoMap()
  public sentOn: Date | null = null;

  @AutoMap()
  public status!: ReminderLogStatusEnum;

  @AutoMap()
  public readStatus!: ReminderLogReadStatusEnum;

  @AutoMap()
  public readOn: Date | null = null;
}

export class ReminderLogModel extends TBaseModel {
  @FormField({
    default: '',
    validators: [Validators.required]
  })
  @AutoMap()
  public title!: string;

  @FormField({
    type: 'dateTime',
    previewName: 'sent on',
    default: '',
    validators: []
  })
  @AutoMap()
  public sentOn: Date | null = null;

  @FormField({
    type: 'select',
    selectTypeValues: Object.values(ReminderLogStatusEnum).filter((v): v is number => typeof v === 'number') as number[],
    selectTypeEnumGeneralModelFunction: reminderLogStatusEnumToGeneralTypeModel,
    default: ReminderLogStatusEnum.Pending,
    validators: []
  })
  @AutoMap()
  public status!: ReminderLogStatusEnum;

  @FormField({
    type: 'select',
    previewName: 'read status',
    selectTypeValues: Object.values(ReminderLogReadStatusEnum).filter((v): v is number => typeof v === 'number') as number[],
    selectTypeEnumGeneralModelFunction: reminderLogReadStatusEnumToGeneralTypeModel,
    default: ReminderLogReadStatusEnum.Unread,
    validators: []
  })
  @AutoMap()
  public readStatus!: ReminderLogReadStatusEnum;

  @FormField({
    type: 'dateTime',
    previewName: 'read on',
    default: '',
    validators: []
  })
  @AutoMap()
  public readOn: Date | null = null;

  @AutoMap()
  public errorMessage!: string | null;

  @AutoMap()
  public reminderLogHighlights!: ReminderLogHighlightGetResponseDto[] | null;
}
